import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    if (document.cookie.includes("coingate-dismissed-promotion=true")) {
      this.element.classList.add("hidden")
    }
  }

  closePromoBar() {
    this.element.classList.add("hidden")
    const expires = new Date(Date.now() + 30 * 864e5).toUTCString()
    document.cookie = `coingate-dismissed-promotion=true; expires=${expires}; path=/`
  }
}
